export const PAYMENT_SET_PAGINATION = "PAYMENT_SET_PAGINATION";
export const PAYMENT_SET_FILTERS = "PAYMENT_SET_FILTERS";
export const PAYMENT_RESET_FILTERS = "PAYMENT_RESET_FILTERS";
export const PAYMENT_SET_SORTING = "PAYMENT_SET_SORTING";
export const EVENT_PAYMENT_FILTER_SUBMIT = "EVENT_PAYMENT_FILTER_SUBMIT";
